/**
 * Lightweight route prefetcher.
 *
 * Hovering over a Link briefly indicates intent to navigate. We preload the
 * matching chunk so the navigation feels instant. Each chunk is loaded at
 * most once and cached by webpack — repeated calls are no-ops.
 */

const prefetchers = {
  '/dashboard': () => import('../pages/DashboardPage'),
  '/saved': () => import('../pages/DashboardPage'),
  '/add-property': () => import('../pages/AddPropertyPage'),
  '/login': () => import('../pages/LoginPage'),
  '/register': () => import('../pages/RegisterPage'),
  '/pricing': () => import('../pages/PricingPage'),
  // '/admin' intentionally not prefetched — stealth route, loaded only on direct nav.
  '/ai-assistant': () => import('../pages/AIAssistantPage'),
  '/seller-dashboard': () => import('../pages/SellerDashboard'),
  '/privacy': () => import('../pages/PrivacyPage'),
  '/terms': () => import('../pages/TermsPage'),
  '/cookies': () => import('../pages/CookiesPage'),
  '/compare': () => import('../pages/ComparePage'),
  '/map': () => import('../pages/MapSearchPage'),
  '/saved-searches': () => import('../pages/SavedSearchesPage'),
};

export const prefetchRoute = (path) => {
  const fn = prefetchers[path];
  if (fn) {
    try {
      fn();
    } catch {
      /* ignore */
    }
  }
};

/**
 * Hook returns props you spread onto <Link> to enable hover-prefetching.
 *
 *   const prefetchProps = useLinkPrefetch('/pricing');
 *   <Link to="/pricing" {...prefetchProps}>Pricing</Link>
 */
export const useLinkPrefetch = (to) => ({
  onMouseEnter: () => prefetchRoute(to),
  onFocus: () => prefetchRoute(to),
});
